export var VERSION = '1.12.1';
//# sourceMappingURL=version.js.map